import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { Button, Card, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import Breadcrumb from '../../Common/BreadCrumb';
import CountUp from 'react-countup';
import TableContainer from "../../Common/TableContainer";
import { userList } from "../../Common/data";
import Flatpickr from "react-flatpickr";
import dummyImg from "../../assets/images/users/user-dummy-img.jpg"
import { Link } from 'react-router-dom';
import { useUserlistMutation } from '../../Redux/UserSlice';
import { getQueryString } from '../../lib/Validationtext';
import moment from "moment";
import useDebounce from '../../hooks/useDebounce';
import dummyImage from '../../assets/images/dummyImage.png';
import { useGetStatisticsUserQuery, useGetUserByIdMutation, useUpdateUserByIdMutation } from '../../Redux/auth/authApi';
import { toast } from 'react-toastify';


const UsersList = () => {
    document.title = "Users List | Toner eCommerce + Admin React Template";
    const [UserlistFunc, { data: listData, error: listErr, isLoading: listLoading }] = useUserlistMutation();
    const [modal_AddUserModals, setmodal_AddUserModals] = useState(false);
    const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);
    const [page, setPage] = useState(0);
    const [limit, setlimit] = useState(10);
    const [search, setSearch] = useState('');
    const debounceSearch = useDebounce(search, 300)
    const [datesFilter, setDatesFilter] = useState({});

    useEffect(() => {
        UserlistFunc(getQueryString({ page: page + 1, limit: 100, search: debounceSearch, ...datesFilter }))
    }, [page, limit, debounceSearch, datesFilter]);

    const handleFilterDate = (value) => {
        const monthNumber = moment().month() + 1; // Add 1 to get the 1-based month number
        const currentDate = moment();
        const firstDayOfMonth = currentDate.startOf('month');
        const formattedFirstDay = firstDayOfMonth.format('YYYY-MM-DD');
        const currentYear = moment().year();
        // const startDate = moment(`1/1/${currentYear}`, 'YYYY-MM-DD');
        const formattedStartDate = currentDate.clone().subtract(1, 'month').format('YYYY-MM-DD');
        const yesterday = moment().subtract(1, 'days');
        // Get the last date of the current month
        const lastDateOfMonth = currentDate.endOf('month')
        // Get the last date of the previous month
        const last7days = moment().subtract(7, 'days').format('YYYY-MM-DD')

        switch (value) {
            case 'all':
                setDatesFilter({ from: "all", to: "" })
                return;
            case 'Today':
                setDatesFilter({ from: moment(new Date()).format('YYYY-MM-DD'), to: moment(new Date()).format('YYYY-MM-DD') })
                return;
            case 'Yesterday':
                setDatesFilter({ from: yesterday.format('YYYY-MM-DD'), to: moment(new Date()).format('YYYY-MM-DD') })
                return;
            case 'Last 7 Days':
                setDatesFilter({ from: last7days, to: moment(new Date()).format('YYYY-MM-DD') })
                return;
            case 'Last 30 Days':
                setDatesFilter({ from: moment().subtract(30, 'days').format('YYYY-MM-DD'), to: moment(new Date()).format('YYYY-MM-DD') })
                return;
            case 'This Month':
                setDatesFilter({ from: formattedFirstDay, to: lastDateOfMonth.format('YYYY-MM-DD') })
                return;
            case 'Last Month':
                setDatesFilter({ from: formattedStartDate, to: lastDateOfMonth.format('YYYY-MM-DD') })
                return;
            default:
                return null;
        }
    }

    function tog_AddUserModals(cellProps) {
        console.log('cellProp6789s', cellProps)
        // setUserInfo(cellProps)
        // setmodal_AddUserModals(!modal_AddUserModals);
    }

    const checkedAll = useCallback(() => {
        const checkall = document.getElementById("checkAll");
        const ele = document.querySelectorAll(".userCheckBox");

        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        } else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
        checkedbox();
    }, []);


    const [userInfo, setUserInfo] = useState({})

    const checkedbox = () => {
        const ele = document.querySelectorAll(".userCheckBox:checked");
        ele.length > 0 ? setIsMultiDeleteButton(true) : setIsMultiDeleteButton(false);
    }

    const columns = useMemo(
        () => [
            // {
            //     Header: (<div className="form-check">
            //         <input className="form-check-input" type="checkbox" id="checkAll" onClick={() => checkedAll()} />
            //     </div>),
            //     Cell: (cellProps) => {
            //         return (
            //             <div className="form-check">
            //                 <input className="userCheckBox form-check-input" type="checkbox" name="chk_child" value={cellProps.row.original.id} onChange={() => checkedbox()} />
            //             </div>
            //         );
            //     },
            //     id: '#',
            // },
            {
                Header: "User Name",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => {
                    return (<div className="d-flex align-items-center gap-2">
                        <div className="flex-shrink-0">
                            <img src={cellProps.profileImage ? cellProps.profileImage : dummyImage} alt="" className="avatar-xs rounded-circle user-profile-img" />
                        </div>
                        <div className="flex-grow-1 ms-2 user_name">{cellProps.firstName ? cellProps.firstName + " " + cellProps.lastName : '-'}</div>
                    </div>)
                }
            },
            {
                Header: "Email",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) =>
                    cellProps?.email ? cellProps?.email : "-",
            },
            {
                Header: "Phone Number",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) =>
                    cellProps?.phone ? cellProps?.phone : "-",
            },
            {
                Header: "Create Date",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => cellProps.createdAt ? moment(cellProps.createdAt).format('DD-MM-YYYY') : '-',
            },
            {
                Header: "Account Status",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => {
                    switch (cellProps?.isActive) {
                        case true:
                            return (<span className="badge bg-success-subtle text-success"> Active</span>)
                        case false:
                            return (<span className="badge bg-danger-subtle text-danger">Inactive</span>)
                        default:
                            return (<span className="">-</span>)
                    }
                },
            },
            {
                Header: "Action",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => {
                    return (
                        <div className="d-flex gap-2">
                            <div className="edit">
                                <Button variant="ghost-info" size="sm" className="btn-ghost-info btn-icon edit-item-btn" onClick={() => {
                                    getUser(cellProps?.id)
                                    tog_AddUserModals(cellProps)
                                }}><i className="ph-pencil-line"></i></Button>
                            </div>
                            {/* <div className="remove">
                                <Button variant="ghost-danger" size="sm" className="btn-ghost-danger btn-icon remove-item-btn"><i className="ph-trash"></i></Button>
                            </div> */}
                        </div>
                    )
                },
            },
        ],
        [checkedAll]
    );

    const [updateFn, { data: updateData, isSuccess: updateSUccess, error: updateErr }] = useUpdateUserByIdMutation()



    useEffect(() => {
        if (updateSUccess) {
            UserlistFunc(getQueryString({ page: page + 1, limit: limit, search: debounceSearch, ...datesFilter }))

            const message = updateData?.message || "Product created successfully";
            toast.success(message);
            setmodal_AddUserModals(false)
        }
        if (updateErr) {
            if ('data' in updateErr) {
                const errorData = updateErr;
                toast.error(errorData.data.message);

            }
        }
    }, [updateData, updateSUccess, updateErr]);




    const [getUser, { data: userData }] = useGetUserByIdMutation();

    const { data: statisticsData } = useGetStatisticsUserQuery();


    useEffect(() => {
        if (userData?.response?.id) {
            setUserInfo(userData?.response);
            setmodal_AddUserModals(true)

        }

    }, [userData])

    console.log('userData', userData)

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumb title="Users List" pageTitle="More" />

                    <Row>
                        {statisticsData?.response && statisticsData?.response?.map((item) => {
                            return (
                                <Col xxl={3} md={6}>
                                    <Card className="card-height-100 bg-warning-subtle border-0 overflow-hidden">
                                        <div className="position-absolute end-0 start-0 top-0 z-0">
                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
                                                // xmlns:xlink="http://www.w3.org/1999/xlink"
                                                width="400" height="250" preserveAspectRatio="none" viewBox="0 0 400 250">
                                                <g mask="url(&quot;#SvgjsMask1530&quot;)" fill="none">
                                                    <path d="M209 112L130 191" strokeWidth="10" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
                                                    <path d="M324 10L149 185" strokeWidth="8" stroke="url(#SvgjsLinearGradient1532)" strokeLinecap="round" className="TopRight"></path>
                                                    <path d="M333 35L508 -140" strokeWidth="10" stroke="url(#SvgjsLinearGradient1532)" strokeLinecap="round" className="TopRight"></path>
                                                    <path d="M282 58L131 209" strokeWidth="10" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
                                                    <path d="M290 16L410 -104" strokeWidth="6" stroke="url(#SvgjsLinearGradient1532)" strokeLinecap="round" className="TopRight"></path>
                                                    <path d="M216 186L328 74" strokeWidth="6" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
                                                    <path d="M255 53L176 132" strokeWidth="10" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
                                                    <path d="M339 191L519 11" strokeWidth="8" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
                                                    <path d="M95 151L185 61" strokeWidth="6" stroke="url(#SvgjsLinearGradient1532)" strokeLinecap="round" className="TopRight"></path>
                                                    <path d="M249 16L342 -77" strokeWidth="6" stroke="url(#SvgjsLinearGradient1532)" strokeLinecap="round" className="TopRight"></path>
                                                    <path d="M129 230L286 73" strokeWidth="10" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
                                                    <path d="M80 216L3 293" strokeWidth="6" stroke="url(#SvgjsLinearGradient1531)" strokeLinecap="round" className="BottomLeft"></path>
                                                </g>
                                                <defs>
                                                    <mask id="SvgjsMask1530">
                                                        <rect width="400" height="250" fill="#ffffff"></rect>
                                                    </mask>
                                                    <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="SvgjsLinearGradient1531">
                                                        <stop stopColor="rgba(var(--tb-warning-rgb), 0)" offset="0"></stop>
                                                        <stop stopColor="rgba(var(--tb-warning-rgb), 0.2)" offset="1"></stop>
                                                    </linearGradient>
                                                    <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="SvgjsLinearGradient1532">
                                                        <stop stopColor="rgba(var(--tb-warning-rgb), 0)" offset="0"></stop>
                                                        <stop stopColor="rgba(var(--tb-warning-rgb), 0.2)" offset="1"></stop>
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                        </div>
                                        <Card.Body className="p-4 z-1 position-relative">
                                            <h4 className="fs-22 fw-semibold mb-3"><CountUp end={item?.count} separator=',' /> </h4>
                                            <p className="mb-0 fw-medium text-uppercase fs-14">{item?.name}</p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )
                        })}
                    </Row>

                    <Row id="usersList">
                        <Col lg={12}>
                            <Card>
                                <Card.Body>
                                    <Row className="g-lg-2 g-4">
                                        <Col lg={3}>
                                            <div className="search-box">
                                                <input type="text" className="form-control search" placeholder="Search for users..." onChange={(e) => setSearch(e.target.value)} />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>

                                        {/* {isMultiDeleteButton && <Button variant="danger" className="btn-icon"><i className="ri-delete-bin-2-line"></i></Button>} */}

                                        <Col sm={3} className="col-lg-auto ms-auto">
                                            {/* <Button onClick={() => tog_AddUserModals()} variant='primary' type="button" className="w-100 add-btn">
                                                Add User
                                            </Button> */}
                                        </Col>
                                        <Col sm={9} className="col-lg-auto">
                                            <select className="form-select" data-choices data-choices-search-false name="choices-single-default" id="idStatus"
                                                onChange={e => handleFilterDate(e.target.value)}
                                            >
                                                <option defaultValue="all">All</option>
                                                <option value="Today">Today</option>
                                                <option value="Yesterday">Yesterday</option>
                                                <option value="Last 7 Days">Last 7 Days</option>
                                                <option value="Last 30 Days">Last 30 Days</option>
                                                <option value="This Month">This Month</option>
                                                <option value="Last Month">Last Month</option>
                                            </select>

                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Body className='p-0'>

                                    <TableContainer
                                        columns={(columns || [])}
                                        data={(listData?.response?.rows || [])}
                                        // isGlobalFilter={false}
                                        iscustomPageSize={false}
                                        isBordered={false}
                                        customPageSize={10}
                                        className="custom-header-css table align-middle table-nowrap"
                                        tableClass="table-centered align-middle table-nowrap mb-0"
                                        theadClass="text-muted table-light"
                                        SearchPlaceholder='Search Products...'
                                    />
                                    <div className="noresult" style={{ display: "none" }}>
                                        <div className="text-center">
                                            <h5 className="mt-2">Sorry! No Result Found</h5>
                                            <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                                        </div>
                                    </div>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Modal className="fade" show={modal_AddUserModals} onHide={() => { setmodal_AddUserModals(false) }} centered>
                        <Modal.Header className="px-4 pt-4" closeButton>
                            <h5 className="modal-title" id="exampleModalLabel">Update User</h5>
                        </Modal.Header>
                        <Form className="tablelist-form">
                            <Modal.Body className="p-4">
                                <div id="alert-error-msg" className="d-none alert alert-danger py-2"></div>
                                <input type="hidden" id="id-field" />

                                <div className="text-center">
                                    <div className="position-relative d-inline-block">
                                        <div className="position-absolute  bottom-0 end-0">
                                            <label htmlFor="customer-image-input" className="mb-0" data-bs-toggle="tooltip" data-bs-placement="right" title="Select Image">
                                                <div className="avatar-xs cursor-pointer">
                                                    <div className="avatar-title bg-light border rounded-circle text-muted">
                                                        <i className="ri-image-fill"></i>
                                                    </div>
                                                </div>
                                            </label>
                                            <Form.Control className="d-none" defaultValue="" id="users-image-input" type="file" accept="image/png, image/gif, image/jpeg" />
                                        </div>
                                        <div className="avatar-lg p-1">
                                            <div className="avatar-title bg-light rounded-circle">
                                                <img src={userInfo?.profileImage
                                                    ?.url || dummyImg} alt="dummyImg" id="users-img-field" className="avatar-md rounded-circle object-cover" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="mb-3 col-md-6">
                                        <Form.Label htmlFor="user-name">First name</Form.Label>
                                        <Form.Control type="text" id="user-name-field" readOnly value={userInfo?.firstName} placeholder="Enter Name" required />
                                    </div>
                                    <div className="mb-3 col-md-6">
                                        <Form.Label htmlFor="user-name">Last name</Form.Label>
                                        <Form.Control type="text" id="user-name-field" readOnly value={userInfo?.lastName} placeholder="Enter Name" required />
                                    </div>
                                </div>


                                <div className="mb-3">
                                    <Form.Label htmlFor="email-field">User Email</Form.Label>
                                    <Form.Control type="email" id="email-field" placeholder="Enter Email" required readOnly value={userInfo?.email} />
                                </div>
                                <div className="mb-3">
                                    <Form.Label htmlFor="email-field">User Phone</Form.Label>
                                    <Form.Control type="email" id="email-field" placeholder="Enter Email" required readOnly value={userInfo?.phone} />
                                </div>


                                <div className="mb-3">
                                    <Form.Label htmlFor="date-field">Joining Date</Form.Label>
                                    <Flatpickr
                                        className="form-control flatpickr-input"
                                        placeholder='Select Date'
                                        options={{
                                            mode: "range",
                                            dateFormat: "d M, Y",
                                        }}
                                        value={userInfo?.createdAt}
                                        disabled
                                    />
                                </div>

                                <div className='mb-4 pb-4'>
                                    <label htmlFor="account-status" className="form-label">User Status</label>
                                    <select className="form-select" required id="account-status-field" value={userInfo?.isActive} onChange={e => {
                                        setUserInfo(pre => ({ ...pre, isActive: e.target.value }))
                                    }}>
                                        <option value={true}>Active</option>
                                        <option value={false}>inactive</option>
                                    </select>
                                </div>


                                <h5 className="modal-title" id="exampleModalLabel ">User Addresses</h5>


                                {
                                    userInfo?.Addresses?.map((address, ind) => (
                                        <div key={address?.id} className='row'>
                                            <div className="mb-3 col-md-6 ">
                                                <Form.Label htmlFor="email-field">Address</Form.Label>
                                                <Form.Control type="email" id="email-field" placeholder="Enter Email" required readOnly value={`${address?.addressLine1} ${address?.addressLine2} `} />
                                            </div>
                                            <div className="mb-3 col-md-6">
                                                <Form.Label htmlFor="email-field">Country</Form.Label>
                                                <Form.Control type="email" id="email-field" placeholder="Enter Email" required readOnly value={address?.country} />
                                            </div>
                                            <div className="mb-3 col-md-6">
                                                <Form.Label htmlFor="email-field">State</Form.Label>
                                                <Form.Control type="email" id="email-field" placeholder="Enter Email" required readOnly value={address?.state} />
                                            </div>
                                            <div className="mb-3 col-md-6">
                                                <Form.Label htmlFor="email-field">City</Form.Label>
                                                <Form.Control type="email" id="email-field" placeholder="Enter Email" required readOnly value={address?.city} />
                                            </div>




                                        </div>
                                    ))
                                }
                            </Modal.Body>
                            <div className="modal-footer">
                                <div className="hstack gap-2 justify-content-end">
                                    <Button className="btn-ghost-danger" onClick={() => { setmodal_AddUserModals(false) }}>Close</Button>
                                    <Button variant='success' id="add-btn" onClick={() => { updateFn({ id: userInfo?.id, data: { ...userInfo } }) }}>Update User</Button>
                                </div>
                            </div>

                        </Form>
                    </Modal>

                </Container >
            </div >
        </React.Fragment >
    );
};

export default UsersList;
